import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
// KS 20260630: Entfernt wegen Konflikt mit NoopAnimationsModule (app.module.ts) —
// doppelte AnimationRendererFactory ließ DOM-Knoten zerstörter Routen-Komponenten im DOM stehen (Page-Stacking).
//import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { MessageService } from 'primeng/api';
//import { ConfirmationService } from 'primeng/api';
//import { NavigationMenuComponent } from '@sitos-x/frontend-library';
import { LearningCardsComponent } from '@sitos-x/frontend-library';
//import { ChartWidgetComponent } from '@sitos-x/frontend-library';
import { NewsWidgetComponent } from '@sitos-x/frontend-library';
//import { StatsWidgetComponent } from '@sitos-x/frontend-library';
import { BadgesWidgetComponent } from '@sitos-x/frontend-library';
import { StatisticsComponent, CourseStat } from '@sitos-x/frontend-library';
export { createAgendaBlobUrl } from '@sitos-x/frontend-library';
import { CalendarWidgetComponent } from '@sitos-x/frontend-library';
import { CertificatesWidgetComponent } from '@sitos-x/frontend-library';
import { LearningActivityWidgetComponent, DateRangeEvent, DateRange } from '@sitos-x/frontend-library';
import { MyLearningContentWidgetComponent } from '@sitos-x/frontend-library';
//import { WidgetRegistryService } from '@sitos-x/frontend-library';
//import { IWidgetComponent, WidgetConfig, WidgetMetadata } from '@sitos-x/frontend-library';
import { MyLatestCompletionsWidgetComponent } from '@sitos-x/frontend-library';
import { LastCompletionsWidgetComponent } from '@sitos-x/frontend-library';

import { SafeHtmlPipe, TruncateHtmlPipe, TruncateTextPipe, TranslateWithFallbackPipe, ShortDatePipe } from '@sitos-x/frontend-library';

import { FluidModule } from 'primeng/fluid';

import { NewsItem, BadgesItem, CertificateItem, CalendarItem, DayLearningActivity, LearningActivity, MyLearningContentItem, CompletionItem, UserCompletionItem } from '@sitos-x/frontend-library';
import { CourseEvaluation, CourseRatedEvent } from '@sitos-x/frontend-library';
import { SetIsReadEvent } from '@sitos-x/frontend-library';

import { NotificationsComponent, NotificationItem, SetNotificationReadEvent } from '@sitos-x/frontend-library';

// E X P O R T -------------------------------------------------------------

// Re-export for external access
export { NewsWidgetComponent, BadgesWidgetComponent, CalendarWidgetComponent, CertificatesWidgetComponent, LearningActivityWidgetComponent, MyLearningContentWidgetComponent, MyLatestCompletionsWidgetComponent, LastCompletionsWidgetComponent } from '@sitos-x/frontend-library';
//export { StatsWidgetComponent, ChartWidgetComponent } from '@sitos-x/frontend-library';
export { WidgetRegistryService } from '@sitos-x/frontend-library';
export { IWidgetComponent, WidgetConfig, WidgetMetadata  } from '@sitos-x/frontend-library';
export { NotificationsComponent, NotificationItem, SetNotificationReadEvent  } from '@sitos-x/frontend-library';

export { NewsItem, BadgesItem, CertificateItem, CalendarItem, DayLearningActivity, LearningActivity, MyLearningContentItem, CompletionItem, UserCompletionItem };
export { CourseEvaluation, CourseRatedEvent };
export { SetIsReadEvent };

export { DateRangeEvent, DateRange };

export { SafeHtmlPipe, TruncateHtmlPipe, TruncateTextPipe, TranslateWithFallbackPipe, ShortDatePipe };

export type WidgetItem = NewsWidgetComponent | BadgesWidgetComponent | CalendarWidgetComponent | CertificatesWidgetComponent | LearningActivityWidgetComponent| MyLearningContentWidgetComponent | MyLatestCompletionsWidgetComponent | LastCompletionsWidgetComponent;

export { CourseStat }


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule,
    FluidModule,
    LearningCardsComponent,
    StatisticsComponent,
    NewsWidgetComponent,
    BadgesWidgetComponent,
    CalendarWidgetComponent,
    CertificatesWidgetComponent,
    LearningActivityWidgetComponent,
    MyLearningContentWidgetComponent,
    NotificationsComponent,
    MyLatestCompletionsWidgetComponent,
    LastCompletionsWidgetComponent
  ],
  exports: [
    ButtonModule,
    FluidModule,
    //NavigationMenuComponent,
    LearningCardsComponent,
    StatisticsComponent,
    //ChartWidgetComponent,
    NewsWidgetComponent,
    //StatsWidgetComponent,
    BadgesWidgetComponent,
    CalendarWidgetComponent,
    CertificatesWidgetComponent,
    LearningActivityWidgetComponent,
    MyLearningContentWidgetComponent,
    NotificationsComponent,
    MyLatestCompletionsWidgetComponent,
    LastCompletionsWidgetComponent
  ],
  providers: [
    // KS 20260630: provideAnimationsAsync() entfernt — Konflikt mit NoopAnimationsModule (siehe Import oben).
    //provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.darkmode',
        },
      }
    }),
    //MessageService, // KS TEST 20260602
    //ConfirmationService, // KS TEST TEST TEST 
    //WidgetRegistryService
  ]
})
export class SharedFrontendModule {}


